import {useContext} from 'react';

import {BrandFeaturesContext} from './brand-features-context';
import {BrandFeaturesContextType} from './brand-features-context-type';

const emptyBrandFeatures: BrandFeaturesContextType = {
    isInProgress: false,
    featuresByBrand: {},
};

/**
 * Per-brand features are the brand's own active licences, so they answer what the account-wide
 * feature flags cannot: whether *this* review's brand may use a licensed capability.
 */
export function useBrandFeatures(): BrandFeaturesContextType {
    return useContext(BrandFeaturesContext) ?? emptyBrandFeatures;
}
